var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, InputTextarea, Typography } from "@uigovpe/components";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getApiErrorMessage } from "../../../apis/http";
import { getHearingById } from "../../../apis/hearings";
import { createHearingContribution, getMyHearingContribution, updateHearingContribution, } from "../../../apis/hearingParticipation";
import { useAuth } from "../../auth/AuthContext";
import { HearingCommentsSection } from "../components/HearingCommentsSection";
import { HearingResultsPanel } from "../components/HearingResultsPanel";
import { goToOrLogin } from "../utils/authNavigate";
import { canContributeToHearing, canShowHearingResults, } from "../utils/participation";
var pageShellStyle = {
    display: "flex",
    justifyContent: "center",
    minHeight: "100%",
    padding: "32px 16px 48px",
};
var pageContainerStyle = {
    display: "grid",
    gap: 24,
    maxWidth: 960,
    width: "100%",
};
var titleCardStyle = {
    background: "#FFFFFF",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    borderTop: "8px solid #0B4F8C",
    display: "grid",
    gap: 8,
    padding: 16,
};
var contentCardStyle = {
    background: "#FFFFFF",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
    display: "grid",
    gap: 24,
    padding: 24,
};
var sectionHeaderStyle = {
    borderBottom: "1px solid #E5E7EB",
    display: "grid",
    gap: 8,
    paddingBottom: 16,
};
var tabsBarStyle = {
    borderBottom: "1px solid #D1D5DB",
    display: "flex",
    gap: 4,
};
var tabButtonStyle = {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: 14,
    padding: "8px 16px",
    position: "relative",
};
var feedbackStyles = {
    error: { background: "#FFE4E4", color: "#7A1F1F" },
    info: { background: "#E6F3FF", color: "#0B4F8C" },
    success: { background: "#EAFBD7", color: "#245C15" },
    warning: { background: "#FFF7D6", color: "#7A5800" },
};
var feedbackBoxStyle = {
    borderRadius: 12,
    padding: "12px 16px",
};
var actionsRowStyle = {
    alignItems: "center",
    display: "flex",
    gap: 16,
    justifyContent: "space-between",
};
var FeedbackBox = function (_a) {
    var message = _a.message, severity = _a.severity;
    return (_jsx("div", __assign({ style: __assign(__assign({}, feedbackBoxStyle), feedbackStyles[severity]) }, { children: _jsx(Typography, { children: message }) })));
};
var FormTabButton = function (_a) {
    var active = _a.active, label = _a.label, onClick = _a.onClick;
    return (_jsxs("button", __assign({ "aria-pressed": active, onClick: onClick, style: __assign(__assign({}, tabButtonStyle), { color: active ? "#1451B4" : "#6B7280", fontWeight: active ? 700 : 500 }), type: "button" }, { children: [label, active ? (_jsx("span", { style: {
                    background: "#1451B4",
                    borderRadius: 999,
                    bottom: -1,
                    height: 3,
                    left: 0,
                    position: "absolute",
                    right: 0,
                } })) : null] })));
};
export var HearingOpenContributionPage = function () {
    var id = useParams().id;
    var hearingId = Number(id);
    var hasValidHearingId = Number.isFinite(hearingId) && hearingId > 0;
    var navigate = useNavigate();
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var _b = useAuth(), accessToken = _b.accessToken, hasPortalConnect = _b.hasPortalConnect, hasToken = _b.hasToken, isAuthenticated = _b.isAuthenticated, isLoadingAuth = _b.isLoadingAuth, login = _b.login, role = _b.role;
    var isCitizen = role === "citizen";
    var _c = useState(null), hearing = _c[0], setHearing = _c[1];
    var _d = useState(null), contribution = _d[0], setContribution = _d[1];
    var _e = useState(""), content = _e[0], setContent = _e[1];
    var _f = useState(false), isEditingContribution = _f[0], setIsEditingContribution = _f[1];
    var _g = useState(null), feedback = _g[0], setFeedback = _g[1];
    var _h = useState(true), loading = _h[0], setLoading = _h[1];
    var _j = useState(null), pageError = _j[0], setPageError = _j[1];
    var _k = useState(false), submitting = _k[0], setSubmitting = _k[1];
    var _l = useState(function () {
        return searchParams.get("tab") === "responses" ? "responses" : "questions";
    }), selectedTab = _l[0], setSelectedTab = _l[1];
    var openForContribution = hearing
        ? canContributeToHearing(hearing.status)
        : false;
    var showAggregateResults = hearing
        ? canShowHearingResults(hearing.status)
        : false;
    var canSubmitContribution = isAuthenticated &&
        isCitizen &&
        openForContribution &&
        (hearing === null || hearing === void 0 ? void 0 : hearing.contributionType) === "open_contribution";
    var syncContribution = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!accessToken || !hasValidHearingId) {
                        setContribution(null);
                        setContent("");
                        setIsEditingContribution(false);
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getMyHearingContribution(hearingId, accessToken)];
                case 2:
                    response = _b.sent();
                    setContribution(response.data.contribution);
                    setContent(response.data.contribution.content || "");
                    setIsEditingContribution(false);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    setContribution(null);
                    setIsEditingContribution(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [accessToken, hasValidHearingId, hearingId]);
    useEffect(function () {
        if (!hasValidHearingId) {
            setPageError("Audiência inválida.");
            setLoading(false);
            return;
        }
        if (isLoadingAuth) {
            return;
        }
        var mounted = true;
        var load = function () { return __awaiter(void 0, void 0, void 0, function () {
            var hearingResponse, loadError_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        setPageError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, getHearingById(hearingId, accessToken)];
                    case 2:
                        hearingResponse = _a.sent();
                        if (!mounted) {
                            return [2 /*return*/];
                        }
                        setHearing(hearingResponse.data.publicHearing);
                        return [4 /*yield*/, syncContribution()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        loadError_1 = _a.sent();
                        if (mounted) {
                            setPageError(getApiErrorMessage(loadError_1));
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        if (mounted) {
                            setLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        void load();
        return function () {
            mounted = false;
        };
    }, [
        accessToken,
        hasValidHearingId,
        hearingId,
        isLoadingAuth,
        syncContribution,
    ]);
    var handleTabChange = function (tab) {
        setSelectedTab(tab);
        if (tab === "responses") {
            setSearchParams({ tab: "responses" });
        }
        else {
            setSearchParams({});
        }
    };
    var requireAuth = function () {
        goToOrLogin({
            hasPortalConnect: hasPortalConnect,
            hasToken: hasToken,
            isAuthenticated: isAuthenticated,
            login: login,
            navigate: navigate,
            path: "/hearings/contribution/".concat(hearingId),
        });
    };
    var handleSubmitManifestation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var wasUpdate, submitError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!hearing || !content.trim()) {
                        return [2 /*return*/];
                    }
                    if (!accessToken) {
                        requireAuth();
                        return [2 /*return*/];
                    }
                    if (!canSubmitContribution) {
                        return [2 /*return*/];
                    }
                    setSubmitting(true);
                    setFeedback(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    if (!contribution) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateHearingContribution(hearing.id, contribution.id, { content: content.trim() }, accessToken)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createHearingContribution(hearing.id, { content: content.trim() }, accessToken)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    wasUpdate = Boolean(contribution);
                    return [4 /*yield*/, syncContribution()];
                case 6:
                    _a.sent();
                    setIsEditingContribution(false);
                    setFeedback({
                        message: wasUpdate
                            ? "Manifestação atualizada com sucesso."
                            : "Manifestação enviada com sucesso.",
                        severity: "success",
                    });
                    return [3 /*break*/, 9];
                case 7:
                    submitError_1 = _a.sent();
                    setFeedback({
                        message: getApiErrorMessage(submitError_1),
                        severity: "error",
                    });
                    return [3 /*break*/, 9];
                case 8:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var startEditingContribution = function () {
        setContent((contribution === null || contribution === void 0 ? void 0 : contribution.content) || "");
        setIsEditingContribution(true);
        setFeedback(null);
    };
    var cancelEditingContribution = function () {
        setContent((contribution === null || contribution === void 0 ? void 0 : contribution.content) || "");
        setIsEditingContribution(false);
        setFeedback(null);
    };
    var showContributionEditor = !contribution || isEditingContribution;
    return (_jsx("div", __assign({ style: pageShellStyle }, { children: _jsxs("div", __assign({ style: pageContainerStyle }, { children: [_jsx("div", { children: _jsxs("button", __assign({ onClick: function () {
                            return navigate(hearing
                                ? "/hearings/details/".concat(hearing.id)
                                : "/hearings/details/".concat(hearingId));
                        }, style: {
                            alignItems: "center",
                            background: "#FFFFFF",
                            border: "1px solid #1451B4",
                            borderRadius: 8,
                            boxSizing: "border-box",
                            color: "#1451B4",
                            cursor: "pointer",
                            display: "inline-flex",
                            fontSize: 14,
                            fontWeight: 600,
                            gap: 8,
                            height: 32,
                            padding: "0 16px",
                        }, type: "button" }, { children: [_jsx("span", __assign({ "aria-hidden": "true" }, { children: "\u2190" })), "Voltar para a audi\u00EAncia"] })) }), feedback ? _jsx(FeedbackBox, __assign({}, feedback)) : null, loading || isLoadingAuth ? (_jsx(Typography, { children: "Carregando contribui\u00E7\u00E3o..." })) : pageError || !hearing ? (_jsxs("div", __assign({ style: { display: "grid", gap: 16 } }, { children: [_jsx(FeedbackBox, { message: pageError || "Audiência não encontrada.", severity: "error" }), _jsx("div", { children: _jsx(Button, { label: "Voltar para o in\u00EDcio", onClick: function () { return navigate("/"); } }) })] }))) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: titleCardStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", size: "lg" }, { children: hearing.title })), hearing.description ? (_jsx(Typography, { children: hearing.description })) : null] })), _jsxs("div", __assign({ style: tabsBarStyle }, { children: [_jsx(FormTabButton, { active: selectedTab === "questions", label: "Quest\u00F5es", onClick: function () { return handleTabChange("questions"); } }), _jsx(FormTabButton, { active: selectedTab === "responses", label: "Respostas", onClick: function () { return handleTabChange("responses"); } })] })), selectedTab === "responses" ? (showAggregateResults ? (_jsx(HearingResultsPanel, { hearingId: hearing.id })) : (_jsx("div", __assign({ style: contentCardStyle }, { children: _jsx(Typography, { children: "Os resultados agregados ficam dispon\u00EDveis ap\u00F3s o encerramento da audi\u00EAncia." }) })))) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: contentCardStyle }, { children: [!isLoadingAuth && !hasToken ? (_jsx(FeedbackBox, { message: "Fa\u00E7a login pelo Smartpass para registrar sua contribui\u00E7\u00E3o, responder coment\u00E1rios e apoiar manifesta\u00E7\u00F5es.", severity: "info" })) : null, isAuthenticated && !isCitizen ? (_jsx(FeedbackBox, { message: "Apenas perfis citizen podem enviar contribui\u00E7\u00F5es nesta tela.", severity: "info" })) : null, !openForContribution ? (_jsx(FeedbackBox, { message: "Esta audi\u00EAncia n\u00E3o est\u00E1 mais recebendo novas contribui\u00E7\u00F5es.", severity: "warning" })) : null, hearing.contributionType !== "open_contribution" ? (_jsx(FeedbackBox, { message: "Esta audi\u00EAncia utiliza formul\u00E1rio estruturado. Use o fluxo correto em /hearings/form/".concat(hearing.id, "."), severity: "warning" })) : null, _jsxs("div", __assign({ style: sectionHeaderStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", size: "md" }, { children: "Envie sua contribui\u00E7\u00E3o" })), showContributionEditor ? (_jsx(Typography, { children: contribution
                                                        ? "Atualize sua manifestação enquanto a audiência estiver disponível."
                                                        : "Manifestação principal (única por cidadão). Digite sua resposta aqui..." })) : null] })), showContributionEditor ? (_jsxs(_Fragment, { children: [_jsx(InputTextarea, { disabled: !canSubmitContribution, onChange: function (event) {
                                                        return setContent(event.target.value);
                                                    }, placeholder: "Digite sua resposta aqui...", rows: 4, value: content }), _jsxs("div", __assign({ style: actionsRowStyle }, { children: [contribution ? (_jsx(Button, { label: "Cancelar", link: true, onClick: cancelEditingContribution, severity: "secondary" })) : (_jsx(Button, { label: "Limpar formul\u00E1rio", link: true, onClick: function () { return setContent(""); }, severity: "secondary" })), !hasToken && !isAuthenticated ? (_jsx(Button, { label: "Fa\u00E7a login para enviar", onClick: requireAuth, severity: "secondary" })) : (_jsx(Button, { disabled: submitting ||
                                                                !content.trim() ||
                                                                !canSubmitContribution, label: submitting
                                                                ? "Enviando..."
                                                                : contribution
                                                                    ? "Salvar"
                                                                    : "Enviar", onClick: function () { return void handleSubmitManifestation(); } }))] }))] })) : (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ fontWeight: "medium" }, { children: "Sua contribui\u00E7\u00E3o registrada:" })), _jsx("div", __assign({ style: {
                                                        borderLeft: "4px solid #1451B4",
                                                        display: "grid",
                                                        gap: 8,
                                                        paddingLeft: 16,
                                                    } }, { children: _jsx(Typography, __assign({ style: {
                                                            color: "#111827",
                                                            lineHeight: 1.6,
                                                            whiteSpace: "pre-wrap",
                                                            wordBreak: "break-word",
                                                        } }, { children: contribution.content })) })), _jsx("div", __assign({ style: __assign(__assign({}, actionsRowStyle), { justifyContent: "flex-end" }) }, { children: _jsx(Button, { disabled: !canSubmitContribution, label: "Atualizar", onClick: startEditingContribution }) }))] }))] })), _jsxs("div", __assign({ style: contentCardStyle }, { children: [_jsx("div", __assign({ style: sectionHeaderStyle }, { children: _jsx(Typography, __assign({ fontWeight: "bold", size: "md" }, { children: "Coment\u00E1rios e respostas" })) })), _jsx(HearingCommentsSection, { hearingId: hearing.id, hearingStatus: hearing.status, showDisclaimer: false })] }))] }))] }))] })) })));
};
